import { render, staticRenderFns } from "./IntraoralListItem.vue?vue&type=template&id=11ec85f0&scoped=true&"
import script from "./IntraoralListItem.vue?vue&type=script&lang=js&"
export * from "./IntraoralListItem.vue?vue&type=script&lang=js&"
import style0 from "./IntraoralListItem.vue?vue&type=style&index=0&id=11ec85f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ec85f0",
  null
  
)

export default component.exports